import { render } from "./ligacaoBaseDados.vue?vue&type=template&id=d94b5452&scoped=true"
import script from "./ligacaoBaseDados.vue?vue&type=script&lang=js"
export * from "./ligacaoBaseDados.vue?vue&type=script&lang=js"

import "./ligacaoBaseDados.vue?vue&type=style&index=0&id=d94b5452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94b5452"]])

export default __exports__